import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { version } from '../../../environments/version';

@Injectable({
    providedIn: 'root'
})
export class VersionCheckService {
    private currentHash = version.hash;

    constructor(private http: HttpClient) { }

    public async checkVersion(url: string = 'assets/version.json') {
        // timestamp to avoid caching
        const versionUrl = `${url}?t=${new Date().getTime()}`;

        try {
            const response: any = await firstValueFrom(this.http.get(versionUrl));
            const newHash = response.hash;

            if (this.currentHash !== newHash) {
                // Reload the page to get fresh assets
                window.location.reload();
            }
        } catch (err) {
        }
    }
}
